import React, { forwardRef, RefObject, useEffect, useState } from 'react';
import { useRef } from 'react';
import { getResolutionValue, RESOLUTION, VideoElementProps } from '@domain/constant/webcamTypes';
import styles from './Webcam.module.scss';
import classNames from 'classnames/bind';
import { AudioRecordingBadge } from './audioRecordBadge/audioRecordingBadge';
import RecordBadge from './recordBadge';

const cx = classNames.bind(styles);

interface Props {
  stream: MediaStream | null;
  initialized: boolean;
  videoRecording?: boolean;
  micActive?: boolean;
  leftTime?: number;
}

const Webcam = forwardRef<HTMLVideoElement, VideoElementProps & Props>((props, ref) => {
  const {
    className,
    autoPlay = true,
    muted = true,
    loop = true,
    // resolution = RESOLUTION.VGA,
    videoRecording,
    handleMounted,
    handlePlay,
    handleError,
    initialized,
    stream,
    micActive,
    leftTime,
  } = props;

  useEffect(() => {
    if (initialized && videoRef.current) {
      if (handleMounted) {
        handleMounted();
      }

      videoRef.current.srcObject = stream;

      videoRef.current.play().then(handlePlay).catch(handleError);
    }
  }, [stream, initialized]);

  const cns = cx('webcam');

  const videoRef = ref ? (ref as RefObject<HTMLVideoElement>) : useRef<HTMLVideoElement>(null);
  // const resolutionValue = getResolutionValue(resolution);

  return (
    <div className={cx('webcamContainer', className)}>
      <video
        ref={videoRef}
        className={cns}
        autoPlay={autoPlay || undefined}
        muted={muted || undefined}
        loop={loop || undefined}
        style={{ objectFit: 'cover' }}
      />
      {videoRecording ? <RecordBadge leftTime={leftTime} /> : <AudioRecordingBadge active={micActive} />}
    </div>
  );
});

export default Webcam;
